import styled from 'styled-components';

export const GaugeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
`;

export const GaugeTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #8c8c8c;
  width: 70px;
`;

export const GaugeChartWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-width: 70px;
  margin-right: 10px;
`;

export const GaugeValue = styled.div`
  font-size: 20px;
  font-weight: 600;
  position: relative;
  z-index: 1;
  cursor: help;
`;

export const GaugeContentWrapper = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 4px;
  flex: 1;
`;

export const GaugeLeft = styled.div`
  display: flex;
  align-items: center;
  width: 70px;
`;

export const ThresholdContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: auto;

  .top {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .bottom {
    display: flex;
    align-items: center;
    padding-top: 4px;
    border-top: 1px solid rgb(0 0 0 / 6%);
  }
`;

export const MetricItem = styled.div`
  font-size: 12px;
  color: rgb(0 0 0 / 45%);
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  .value {
    color: rgb(0 0 0 / 85%);
    font-weight: 500;
  }
`;
